import { ReactNode } from "react";

import { cn } from "@/lib/utils";
import { PublicHeader } from "@/modules/landing/ui/public-header";
import { useSignedIn } from "@/pages/landing-session";
import { TOOLS_CONTAINER } from "@/pages/tools/_ui/tools-container";
import ToolsCta from "@/pages/tools/_ui/tools-cta";

// 무료 도구 공용 틀 — 로그인 없이 열리고, 머리(공개 화면 공용 · contents 라 sticky 유지)·바닥 안내는 인쇄에서 빠진다.
export const ToolsLayoutView = ({ signedIn, children }: { signedIn: boolean; children: ReactNode }) => (
  <div className="flex min-h-dvh flex-col">
    <div className="print-hide contents" data-testid="tools-header">
      <PublicHeader container={TOOLS_CONTAINER} signedIn={signedIn} />
    </div>
    <main className={cn(TOOLS_CONTAINER, "flex-1 py-6")}>{children}</main>
    <ToolsCta />
  </div>
);

const ToolsLayout = ({ children }: { children: ReactNode }) => <ToolsLayoutView signedIn={useSignedIn()}>{children}</ToolsLayoutView>;

export default ToolsLayout;
